// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { shortenSizeUnit } from '../../utils';
import { Table } from '../common/table';
import type { ColumnType } from '../common/table/Table';
import type { CropImportRowOut } from './parseCropUpload';

interface Props {
  readonly crops: readonly CropImportRowOut[];
}

function shortenSowDensityUnit(unit: string): string {
  // grams, ounces, teaspoons, tablespoons, cups
  switch (unit) {
    case 'grams':
      return 'g';
    case 'ounces':
      return 'oz';
    case 'teaspoons':
      return 'tsp';
    case 'tablespoons':
      return 'tbsp';
    case 'cups':
      return 'c';
    default:
      return unit;
  }
}

export default function ParseCropsTable({ crops }: Props) {
  const nameVals: string[] = [];
  const growTimeVals: string[] = [];
  const stepCounts: number[] = [];
  const yieldValues: string[] = [];
  const sowDensityValues: string[] = [];
  const sizeValues: number[] = [];
  for (const crop of crops) {
    nameVals.push(crop.name);
    growTimeVals.push(`${crop.growTimeDays} days`);
    stepCounts.push(crop.steps.length);
    sizeValues.push(crop.sizes.length);
    yieldValues.push(`${crop.yieldPerTray} ${shortenSizeUnit(crop.yieldPerTrayUnit)}`);
    sowDensityValues.push(
      crop.sowDensityPerTray == null || crop.sowDensityUnit == null
        ? ''
        : `${crop.sowDensityPerTray} ${shortenSowDensityUnit(crop.sowDensityUnit)}`,
    );
  }
  const columns: ColumnType[] = [
    {
      name: 'Name',
      values: nameVals,
    },
    {
      name: 'Yield Per Tray',
      smallName: 'Yield',
      values: yieldValues,
    },
    {
      name: 'Sow Density',
      values: sowDensityValues,
      visibleAt: 'sm',
    },
    {
      name: 'Grow Time',
      values: growTimeVals,
    },
    {
      name: 'Sizes',
      values: sizeValues,
      numeric: true,
      visibleAt: 'md',
    },
    {
      name: 'Steps',
      values: stepCounts,
      numeric: true,
      visibleAt: 'md',
    },
  ];

  return <Table columns={columns} />;
}
